<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <!-- 头部 -->
    <div class="page-heading">
      <div class="container">
        <div class="heading-content">
          <h1>华胤创造</h1>
        </div>
      </div>
    </div>
    <!-- 导航栏 -->
    <div class="tabs tabs-style-linebox hidden-xs">
      <div class="zznav">
        <ul class="zzitem">
          <li><a @click="forId('hysj')">华胤设计</a></li>
          <li><a @click="forId('zpjx')">作品解析</a></li>
        </ul>
      </div>
    </div>
    <!-- 小滚轮 -->
    <div id="ss_menu" style="display: block;">
      <div>
        <i
          ><a @click="forId('zpjx')">作品<br />解析</a></i
        >
      </div>
      <div>
        <i
          ><a @click="forId('hysj')">华胤<br />设计</a></i
        >
      </div>
      <div class="menu">
        <div class="share" id="ss_toggle" data-rot="180">
          <div class="circle"></div>
          <div class="bar"></div>
        </div>
      </div>
    </div>
    <!-- 华胤设计 -->
    <div class="jzcontainer" id="hysj" >
      <div class="jzleft">
        <img v-lazy="hycz1" alt="Lazy-loaded Image" class="jzimg" />
      </div>
      <div class="jzright">
        <h1 class="jzh">华胤设计</h1>
        <p class="jzp">
          依据现代设计理念和国家相应标准进行工程设计。<br />华胤拥有自己的设计中心，并且拥有钢结构设计甲级证书，拥有一支强大的专业设计队伍，分别位于厦门和昆山。<br />采用国际先进的MBS,X-STEEL，PKPM、
          3D3S
          、STAADPRO、MBS、MTS、CFS、XSTEEL等设计软件，能完成结构设计到制造详图的全部设计工作。设计经验超过三千件，涉及不同的领域。<br />提供完整的钢结构制作和安装图纸，使制作及施工能准确高效的进行。
        </p>
      </div>
    </div>
    <!-- 作品解析 -->
    <div id="zpjx"><h1 class="jzcph">作品解析</h1></div>
    <div class="jzcp">
      <div class="cd-image-block">
        <ul class="cd-images-list">
          <li class="is-selected">
            <a href="#0">
              <h2>上海赛科PHU聚合物仓库</h2>
            </a>
          </li>

          <li>
            <a href="#0">
              <h2>宜家上海松江第二期仓库钢结构工程</h2>
            </a>
          </li>

          <li>
            <a href="#0">
              <h2>西安飞机库</h2>
            </a>
          </li>

          <li>
            <a href="#0">
              <h2>长风地区2号（西）地块工程——天鸿F、M</h2>
            </a>
          </li>
          <li>
            <a href="#0">
              <h2>丰田工业汽车配件(昆山)有限公司</h2>
            </a>
          </li>
          <li>
            <a href="#0">
              <h2>创姿服饰(上海)有限公司</h2>
            </a>
          </li>
          <li>
            <a href="#0">
              <h2>YKK吉田拉链(深圳)有限公司 (纺织服装)</h2>
            </a>
          </li>
          <li>
            <a href="#0">
              <h2>中国上海漕泾联合异氰酸酯化工项目</h2>
            </a>
          </li>
          <li>
            <a href="#0">
              <h2>伯利休斯异型钢结构</h2>
            </a>
          </li>
          <li>
            <a href="#0">
              <h2>上海世博会世博中心</h2>
            </a>
          </li>
          <li>
            <a href="#0">
              <h2>巨人桥梁钢结构</h2>
            </a>
          </li>
          <li>
            <a href="#0">
              <h2>武钢园管绗架组合柱</h2>
            </a>
          </li>
        </ul>
        <!-- .cd-images-list -->
        <ul class="block-navigation">
          <li>
            <button class="cd-prev inactive jzbutton">&larr; 上一页</button>
          </li>
          <li><button class="cd-next jzbutton">下一页 &rarr;</button></li>
        </ul>
        <!-- .block-navigation -->
      </div>
      <!-- .cd-image-block -->

      <div class="cd-content-block">
        <ul>
          <li class="is-selected">
            <div>
              <h2>上海赛科PHU聚合物仓库</h2>
              <img
                v-lazy="hycz2"
                alt="Lazy-loaded Image"
                style="width: 50vw; margin: -10px 5px 5px 5px; max-height: 30vh"
              />
              <p>
                上海赛科PHU聚合物仓库为目前国内最大的合资企业及上海化学工业区的龙头企业,主体结构(柱网)长度396m,宽度148m，总建筑面积60927.45m2。两条宽1m的伸缩缝将仓库分成长度分别为151m、88m及153m的三部分，第一及第三部分跨度为2x50m+48m，第二部分跨度为2x50m+30m，主要柱距为8m，局部柱距为10m、9m、7.5m及7m，三脊双坡，屋面坡度1:15，檐口高度8.9m。在6m高度处仓库一面外挑9.75m雨棚，另三面均外挑12m雨棚，雨棚以下开敞。在屋面上布置有一条长度为380m的纵向采光天窗及三条132m的横向采光天窗，每个柱距内设置一条宽度为416mm的采光带。仓库四周设一圈比屋面梁顶高900mm的女儿墙，采用内天沟虹吸式排水系统。屋面采用单层华胤KD镀铝锌压型钢板，在包装区上增设50mm厚12K带WMP-VR贴面的玻璃棉。墙面雨棚以上采用单层华胤CDⅡ洁面镀铝锌彩色压型钢板。在结构设计中考虑了温度荷载及支座位移对结构的影响，并设置了较强的屋面钢管支撑及墙面型钢支撑以承受屋面天窗及抗风柱上的12m雨棚传来的风荷载。
              </p>
            </div>
          </li>

          <li>
            <div>
              <h2>宜家上海松江第二期仓库钢结构工程</h2>
              <img
                v-lazy="hycz3"
                alt="Lazy-loaded Image"
                style="width: 50vw; margin: -10px 5px 5px 5px"
              />
              <p>
                该工程地处上海市松江区洞泾工业园区，结构形式为单栋单层门式钢架轻钢彩板结构。整个建筑分为三个区：低跨区（B区－A~G/1~25）的长*宽*檐高＝107.1m*188m*9.9m；高跨区（A区－H~P/1~25）的长*宽*檐高＝101.8m*188m*29.725m/9.9m;
                低跨区（C区－Q-W/1~25）的长*宽*檐高=110.1m*188m*9.9m，总的建筑面积为63218㎡，双坡屋面。项目面积大，中间区域檐口高度达到30米，高度高，与常规轻钢结构厂房相比，施工难度大。屋面系统为双层板双层檩条（SDⅡ板+4″厚玻璃棉+LND板），墙面系统为单层檩条内外双层板（CDⅡ板+4″带VR贴面保温棉+LND板），依靠纵向轻钢框架找坡，分别在○D轴、○P轴、○H轴、○T轴位置设置横向防火墙。屋面排水为外天沟重力式排水方式。
              </p>
            </div>
          </li>

          <li>
            <div>
              <h2>西安飞机库</h2>
              <img
                v-lazy="hycz4"
                alt="Lazy-loaded Image"
                style="width: 50vw; margin: -10px 5px 5px 5px"
              />
              <p>
                西安飞机库64米的跨度，在数以千计的华胤工程业绩中格外耀眼，即便放眼国内轻钢结构建筑也不愧为屈指可数之作。而钢结构作为一种被日益广泛应用的建筑形式，其特点也从中得以充分施展。<br />
                其一大建筑特点，也是设计的难点在于它的大门八扇宽8.5米、高18米、重约8吨的推拉门拼接而成，由电动遥控的四门联动技术控制开合，按门轨的设置，四扇门为一组可同时缩进或展开。华胤凭借先进的设计理念，确定了斜桁架式的做法，以经济的用钢量，科学地化解了完全合拢的大门与两侧门箱，所形成的1600平方米的受风面积。<br />
                机库的建造过程，被业主形容为“大会战”。华胤作为国内钢结构的领先平拍，以炉火纯青的钢结构安装技术，为争分夺秒的工期命令赢得了时间。48小时，几辆卡车奔驰在千里远的公路上，保证钢柱钢梁准时到货；25天，53根24米高的立柱完全立完，每榀重近30吨的梁与之同步起吊，同时结束；5天，墙屋面彩板安装完毕；82天，从设计蓝图到全面竣工，飞机已顺利进场。<br />
              </p>
            </div>
          </li>

          <li>
            <div>
              <h2>长风地区2号（西）地块工程——天鸿F、M栋写字楼工程</h2>
              <img
                v-lazy="hycz5"
                alt="Lazy-loaded Image"
                style="width: 50vw; margin: -10px 5px 5px 5px"
              />
              <p>
                上海天鸿置业投资有限公司总投资约30亿元，体现现代、滨水、生态等新型商务中心开发理念，集商业、娱乐、办公、酒店等多种物业形态于一体的“北岸•长风”大型综合项目，占地11.6万平方米，总建筑面积约为29万平方米，共有12栋建筑组成。此次由我司参与设计的长风地区2号（西）地块工程—F、M栋（以下简称：天鸿F、M栋）是沿苏州河而建的多栋高品质独立多层办公楼之一，也是我们公司参与设计高档写字楼的又一次尝试。<br />
                本工程主体结构为地下一层混凝土，地上五层钢结构，采用钢管混凝土柱，轻质屋面，玻璃幕墙外立面。总建筑面积为18168平方米,标准层层高4.2m，女儿墙顶标高23.980m，大堂从二层~五层挑空，总高度12.46m，屋顶花园位于五层露台面积约500m2，顶上设置外挑4.1m的铝板挑篷，造型高端大气。
              </p>
            </div>
          </li>
          <li>
            <div>
              <h2>丰田工业汽车配件(昆山)有限公司</h2>
              <img
                v-lazy="hycz6"
                alt="Lazy-loaded Image"
                style="width: 50vw; margin: -10px 5px 5px 5px"
              />
              <p>
                华胤重视每个项目的技术支持及售后服务，在全国分区设立了多个分支机构，保证客户能方便及时地得到华胤的优质服务。大多数著名企业都是华胤的客户，如：金光集团、中国航空货运集团、银鹭集团、六和集团、武汉钢铁集团、顶新集团、扬子石化、Tesco乐购超市、日本川铁、风神汽车、丰田汽车、玖龙纸业、蒙牛乳业、诺基亚移动通讯、菲利浦照明电子、西门子公司、宏基电脑、三星电子、TDK磁带、YKK拉链、巴斯夫石化、日立公司、美的电器、宜家家居等众多国内外知名企业。华胤的工程业绩从食品、电子、造纸、医药到物流、汽车、航空、化工……涵盖各行各业；同时也出口至美国、日本、欧洲、澳州、韩国、泰国、海地甚至南非、安哥拉等非州地区。
              </p>
            </div>
          </li>
          <li>
            <div>
              <h2>创姿服饰(上海)有限公司</h2>
              <img
                v-lazy="hycz7"
                alt="Lazy-loaded Image"
                style="width: 50vw; margin: -10px 5px 5px 5px"
              />
              <p>
                华胤拥有完整的设计中心，有效地保证了设计、制造、及项目管理能够直接沟通及流畅交流。拥有现代化生产工艺的制造工厂为公司提供5万吨重钢构件及3万吨成型构件的产能。品质管理和焊接制造水平通过美国、欧洲、日本、中国等权威认证，华胤工厂通过美国钢结构协会质量认证（AISC），焊接制造质量体系通过美国焊接协会（AWS）（CWF）认证和德国LGA焊接体系认证，通过荷兰DNV、瑞士SGS
                ISO9001质量体系认证，部分产品获得FM全球公司（FM
                Approvals）认证，工厂通过日本全国铁骨评价JSAO
                H级认证；设计与施工分别获得了中国工程设计甲级证书与中国钢结构制造企业一级资质证书。所有制造流程及质量控制遵照标准作业程序。
              </p>
            </div>
          </li>
          <li>
            <div>
              <h2>YKK吉田拉链(深圳)有限公司 (纺织服装)</h2>
              <img
                v-lazy="hycz8"
                alt="Lazy-loaded Image"
                style="width: 50vw; margin: -10px 5px 5px 5px"
              />
              <p>
                华胤钢结构工程（中国）有限公司是一家外商独资企业，隶属于华胤集团，专业从事预制钢结构建筑系统及其相关配件的设计，制造和施工。公司于1994年成立，由一批具有多年美国及澳洲预制钢结构系统经验的专业工程师组成。
                华胤非常自豪能有一支专业的团队为公司高质高效的运作进行管理。通过团队的共同努力，华胤已成功完成了3000多个项目，建筑面积超过1000万平方米，多次荣获“金钢奖”、“工程质量优质奖”等多类奖项。
              </p>
            </div>
          </li>
          <li>
            <div>
              <h2>中国上海漕泾联合异氰酸酯化工项目</h2>
              <img
                v-lazy="hycz9"
                alt="Lazy-loaded Image"
                style="width: 50vw; max-height: 40vh; margin: -10px 5px 5px 5px"
              />
              <p>
                中国上海漕泾联合异氰酸酯化工项目（英文简称：IIP）位于上海漕泾化学工业园区，是由上海巴斯夫聚氨酯有限公司（BASF）、上海联恒异氰酸酯有限公司（SLIC）、亨斯迈聚氨酯上海有限公司(HPS)联合投资建造。华胤负责结点设计，并承揽约占工程总量70%的钢构制作，共计9200吨，全部分布在28个大区块及17个小区块之中。整个工程线条极其复杂，呈现出超凡的飒爽英姿，令钢构风情万千。
              </p>
            </div>
          </li>
          <li>
            <div>
              <h2>伯利休斯异型钢结构</h2>
              <img
                v-lazy="hycz10"
                alt="Lazy-loaded Image"
                style="width: 50vw; max-height: 40vh; margin: -10px 5px 5px 5px"
              />
              <p>
                华胤制造的POLYSIUS炉渣仓库物帽为一个正24边形的锥形立体结构，在这里24支梁将连接于一点，构件尺寸及变形控制要求非常高。结构总体尺寸大端距离4744mm，小端距离3114mm；焊缝长度达到352米，其中全熔透焊缝60米，焊缝操作空间非常有限，对焊接技术有很高的要求。<br />
                伯利休斯W11-17异型钢构为圆柱体状，由16支牛腿将圆柱平分为16等份，每等份22.5°。W11-17总宽5634mm，圆柱内径2600mm，高度1443mm。由于结构复杂，焊接难度大，故需要谨慎施工。
              </p>
            </div>
          </li>
          <li>
            <div>
              <h2>上海世博会世博中心</h2>
              <img
                v-lazy="hycz11"
                alt="Lazy-loaded Image"
                style="width: 50vw; max-height: 40vh; margin: -10px 5px 5px 5px"
              />
              <p>
                上海世博会世博中心采用了新型的屈曲约束支撑作为耗能减震体系，受拉受压时都可以屈服,获得饱满的荷载-位移滞回曲线。这种支撑由低屈服点钢制成的芯板、约束套筒和外套筒组成，由于约束套筒必须对芯板的屈曲有良好的约束作用，并承受芯板的屈曲弯曲对套筒产生的挤压力。所以制造精度和难度非常高。世博演艺中心的造型呈飞碟状，是上海世博会最重要的永久性场馆之一，在世博会期间将承担各类大型演出和活动。演艺中心将建设成一座世界一流水准的现代化演艺场馆。
              </p>
            </div>
          </li>
          <li>
            <div>
              <h2>巨人桥梁钢结构</h2>
              <img
                v-lazy="hycz12"
                alt="Lazy-loaded Image"
                style="width: 50vw; max-height: 40vh; margin: -10px 5px 5px 5px"
              />
              <p>
                巨人桥梁由于同时存在向上起拱、平面弯弧、大桥两侧腹板有14度倾角三个因素，形成一个异常复杂的三维空间结构。这给桥梁的下料、拼装、焊接都带来了难以克服的困难。巨大的桥梁在加工过程中的翻转和运输都带来前所未有的挑战。华胤的技术部门和制造部门突破了这个难题，这使华胤有能力挑战任何的桥梁结构。
              </p>
            </div>
          </li>
          <li>
            <div>
              <h2>武钢园管绗架组合柱</h2>
              <img
                v-lazy="hycz13"
                alt="Lazy-loaded Image"
                style="width: 50vw; max-height: 40vh; margin: -10px 5px 5px 5px"
              />
              <p>
                管桁架钢结构的圆管钢架柱是一种常见的构造形式，它由上、下两截组装而成。上截通常采用常规的BH钢柱，而下截则由双圆管组拼而成。这种设计使得钢柱的结构更加稳固和坚固。<br>
                在这种构造中，牛腿起到了连接上、下两截钢柱的作用，并且采用了插入式的方式将牛腿安装在双圆管柱的顶部。根据牛腿的长度不同，圆管钢架柱可以分为两种类型。其中，圆管钢架柱的最长牛腿长度为2500MM（中柱），而最短牛腿长度为1950MM（边柱）。<br>
                这种设计结构可以提供较好的承载能力和稳定性，适用于各种建筑和结构中。通过使用圆管钢架柱，可以实现快速、高效的组装和安装过程，同时确保结构的强度和稳定性。
              </p>
            </div>
          </li>
        </ul>

        <button class="cd-close jzbutton">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  mounted() {
    // 产品介绍
    $(document).ready(function ($) {
      //store DOM elements
      var imageWrapper = $('.cd-images-list'),
        imagesList = imageWrapper.children('li'),
        contentWrapper = $('.cd-content-block'),
        contentList = contentWrapper.children('ul').eq(0).children('li'),
        blockNavigation = $('.block-navigation'),
        blockNavigationNext = blockNavigation.find('.cd-next'),
        blockNavigationPrev = blockNavigation.find('.cd-prev'),
        //used to check if the animation is running
        animating = false

      //on mobile - open a single project content when selecting a project image
      imageWrapper.on('click', 'a', function (event) {
        event.preventDefault()
        var device = MQ()
        console.log(device)
        $('#ss_menu').toggle();
        
        device == 'mobile' &&
          updateBlock(imagesList.index($(this).parent('li')), 'mobile')
      })

      //on mobile - close visible project when clicking the .cd-close btn
      contentWrapper.on('click', '.cd-close', function () {
        var closeBtn = $(this)
        if (!animating) {
          animating = true

          closeBtn
            .removeClass('is-scaled-up')
            .one(
              'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
              function () {
                contentWrapper
                  .removeClass('is-visible')
                  .one(
                    'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
                    function () {
                      animating = false
                    }
                  )

                $('.cd-image-block').removeClass('content-block-is-visible')
                closeBtn.off(
                  'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend'
                )
              }
            )
        }
        $('#ss_menu').toggle();
      })

      //on desktop - update visible project when clicking the .block-navigation
      blockNavigation.on('click', 'button', function () {
        var direction = $(this),
          indexVisibleblock = imagesList.index(
            imageWrapper.children('li.is-selected')
          )

        if (!direction.hasClass('inactive')) {
          var index = direction.hasClass('cd-next')
            ? indexVisibleblock + 1
            : indexVisibleblock - 1
          updateBlock(index)
        }
      })

      //on desktop - update visible project on keydown
      $(document).on('keydown', function (event) {
        var device = MQ()
        console.log(event.which)
        if (
          event.which == '39' &&
          !blockNavigationNext.hasClass('inactive') &&
          device == 'desktop'
        ) {
          //go to next project
          updateBlock(
            imagesList.index(imageWrapper.children('li.is-selected')) + 1
          )
        } else if (
          event.which == '37' &&
          !blockNavigationPrev.hasClass('inactive') &&
          device == 'desktop'
        ) {
          //go to previous project
          updateBlock(
            imagesList.index(imageWrapper.children('li.is-selected')) - 1
          )
        }
      })

      function updateBlock(n, device) {
        if (!animating) {
          animating = true
          var imageItem = imagesList.eq(n),
            contentItem = contentList.eq(n)

          classUpdate($([imageItem, contentItem]))

          if (device == 'mobile') {
            contentItem.scrollTop(0)
            $('.cd-image-block').addClass('content-block-is-visible')
            contentWrapper
              .addClass('is-visible')
              .one(
                'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
                function () {
                  contentWrapper.find('.cd-close').addClass('is-scaled-up')
                  animating = false
                }
              )
          } else {
            contentList.addClass('overflow-hidden')
            contentItem.one(
              'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
              function () {
                contentItem.siblings().scrollTop(0)
                contentList.removeClass('overflow-hidden')
                animating = false
              }
            )
          }

          //if browser doesn't support transition
          if ($('.no-csstransitions').length > 0) animating = false

          updateBlockNavigation(n)
        }
      }

      function classUpdate(items) {
        items.each(function () {
          var item = $(this)
          item
            .addClass('is-selected')
            .removeClass('move-left')
            .siblings()
            .removeClass('is-selected')
            .end()
            .prevAll()
            .addClass('move-left')
            .end()
            .nextAll()
            .removeClass('move-left')
        })
      }

      function updateBlockNavigation(n) {
        n == 0
          ? blockNavigationPrev.addClass('inactive')
          : blockNavigationPrev.removeClass('inactive')
        n + 1 >= imagesList.length
          ? blockNavigationNext.addClass('inactive')
          : blockNavigationNext.removeClass('inactive')
      }

      function MQ() {
        return window
          .getComputedStyle(imageWrapper.get(0), '::before')
          .getPropertyValue('content')
          .replace(/'/g, '')
          .replace(/"/g, '')
          .split(', ')
      }
    })
  },
  data() {
    return {
      isShown:true,
      hycz1: require('@/components/img/hycz/hysj1.jpg'),
      hycz2: require('@/components/img/hycz/zpjx1.jpg'),
      hycz3: require('@/components/img/hycz/zpjx2.jpg'),
      hycz4: require('@/components/img/hycz/zpjx3.jpg'),
      hycz5: require('@/components/img/hycz/zpjx4.jpg'),
      hycz6: require('@/components/img/hycz/zpjx5.jpg'),
      hycz7: require('@/components/img/hycz/zpjx6.jpg'),
      hycz8: require('@/components/img/hycz/zpjx7.jpg'),
      hycz9: require('@/components/img/hycz/zpjx8.jpg'),
      hycz10: require('@/components/img/hycz/zpjx9.jpg'),
      hycz11: require('@/components/img/hycz/zpjx10.jpg'),
      hycz12: require('@/components/img/hycz/zpjx11.jpg'),
      hycz13: require('@/components/img/hycz/zpjx12.jpg'),
    }
  },
  methods:{
    // 调用全局方法，滚动指定id
    forId(tId) {
      console.log(tId);
      this.$store.dispatch('toID', tId);
    },
    changeShow(){
      this.showButton=!this.showButton
    }
  }
}
</script>

<style scoped>
#hysj,
#zpjx {
  margin-top: -83px;
  padding-top: 83px;
}
/* 头部 */
.page-heading {
  background-image: url(@/components/img/hycz/one2.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  text-align: center;
}

.page-heading .heading-content h1 {
  font-size: 32px;
  text-transform: uppercase;
  color: #fff;
  letter-spacing: 1px;
  background-color: rgba(5, 5, 5, 0.9);
  display: inline-block;
  margin-bottom: 0;
  margin-top: 220px;
  padding: 20px 60px;
}

.page-heading .heading-content em {
  font-style: normal;
  font-weight: 200;
}
/* 导航栏 */
.zznav {
  position: relative;
  width: 100%;
  height: 65px;
  background-color: #262626;
}
.zzitem {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  padding: 0;
  display: flex; /*弹性布局，使li排成一行*/
}
.zzitem li {
  list-style: none;
}
.zzitem li a {
  position: relative;
  display: block;
  padding: 10px 20px;
  margin: 0 40px;
  text-decoration: none;
  text-transform: uppercase; /*将字符转为大写*/
  color: #8f8c8c;
  font-weight: bold;
  font-size: 22px;
  cursor: pointer;
  /* transition: 0.5s; */
}
.zzitem li a:hover {
  color: #fff;
}
.zzitem li a:before {
  /*a:before，在a链接之前添加新内容，这里添加上下边框*/
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-top: 2px solid #a56c41;
  border-bottom: 2px solid #a56c41;
  transform: scaleY(2); /*拉长边框两倍*/
  opacity: 0; /*边距不显示*/
  transition: 0.5s;
  z-index: -1;
}
.zzitem li a:hover:before {
  transform: scaleY(1); /*拉长边框两倍*/
  opacity: 1;
}
.zzitem li a:after {
  content: '';
  position: absolute;
  top: 1px;
  left: 0;
  width: 100%;
  height: 100%;
  background: #a56c41;
  transform: scale(0);
  transition: 0.5s;
  z-index: -1;
}
.zzitem li a:hover:after {
  transform: scale(1);
}
/* 小滚轮 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  display: block;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #a56c41;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 12px;
  text-align: center;
  background: #a56c41;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #ed9048;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: -75px;
  left: -25px;
}

#ss_menu div:nth-child(2) {
  top: -25px;
  left: -75px;
}

/* hysg */
.jzcontainer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.jzh {
  text-align: center;
  font-size: 50px;
  font-weight: 600;
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: #262626 solid 1px;
}
.jzp {
  font-weight: 400;
  font-size: 20px;
}
.jzleft {
  flex: 1;
  margin: 20px;
  padding: 20px;
  background-color: rgba(250, 250, 250, 0.1);
  /* text-align: center;
    line-height: auto; */
  color: #000;
  /* box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, rgba(0, 0, 0, 0.07) 0px 16px 16px; */
}

.jzright {
  flex: 1;
  margin: 20px;
  padding: 20px;
  box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px,
    rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;
}

.jzimg {
  max-width: 100%;
  height: auto;
  box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px,
    rgba(255, 255, 255, 0.8) -6px -2px 16px 0px;
}
.jzcp {
  width: 99vw;
  height: 90vh;
}
.hyp {
  font-size: 20px;
  font-weight: 400;
}
@media (max-width: 768px) {
  .hyp {
    font-size: 15px;
    font-weight: 400;
  }
  .jzleft,
  .jzright {
    flex: 100%;
  }

  .jzleft {
    order: 1;
    margin: 0;
  }
  .jzh {
    text-align: center;
    font-size: 35px;
    font-weight: 500;
    margin-bottom: 10px;
    padding-bottom: 10px;
  }
  .jzp {
    font-weight: 100;
    font-size: 1.25em;
  }
  .jzright {
    order: 2;
  }
  .jzcp {
    width: 100vw;
    height: auto;
  }
  .jzcph {
    font-size: 35px !important;
    font-weight: 500 !important;
  }
}
/* 产品内容 */
/* -------------------------------- 

Images block

-------------------------------- */
.jzcph {
  text-align: center;
  padding: 30px 0;
  font-size: 50px;
  font-weight: 600;
  border-top: #000 solid 1px;
  border-bottom: #000 solid 1px;
}
.cd-image-block {
  position: relative;
}
.cd-image-block::before {
  /* this is the layer used to cover the .cd-image-block when the content block becomes visible - mobile only */
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(52, 54, 66, 0.6);
  opacity: 0;
  visibility: hidden;
  -webkit-transition: opacity 0.3s 0s, visibility 0s 0.3s;
  -moz-transition: opacity 0.3s 0s, visibility 0s 0.3s;
  transition: opacity 0.3s 0s, visibility 0s 0.3s;
}
.cd-image-block.content-block-is-visible::before {
  opacity: 1;
  visibility: visible;
  -webkit-transition: opacity 0.3s 0s, visibility 0s 0s;
  -moz-transition: opacity 0.3s 0s, visibility 0s 0s;
  transition: opacity 0.3s 0s, visibility 0s 0s;
}
@media only screen and (min-width: 768px) {
  .cd-image-block::before {
    display: none;
  }
}

.cd-images-list::before {
  /* never visible - this is used in jQuery to check the current MQ */
  content: 'mobile';
  display: none;
}
.cd-images-list > li {
  height: 250px;
  background: #979c9c url(@/components/img/hycz/zp1.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(2) {
  background: #343642 url(@/components/img/hycz/zp2.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(3) {
  background: #982b3c url(@/components/img/hycz/zp3.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(4) {
  background: #338899 url(@/components/img/hycz/zp4.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(5) {
  background: #8b96da url(@/components/img/hycz/zp5.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(6) {
  background: #8b96da url(@/components/img/hycz/zp6.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(7) {
  background: #8b96da url(@/components/img/hycz/zp7.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(8) {
  background: #8b96da url(@/components/img/hycz/zp8.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(9) {
  background: #8b96da url(@/components/img/hycz/zp9.png) no-repeat center center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(10) {
  background: #8b96da url(@/components/img/hycz/zp10.png) no-repeat center
    center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(11) {
  background: #8b96da url(@/components/img/hycz/zp11.png) no-repeat center
    center;
  background-size: cover;
}
.cd-images-list > li:nth-of-type(12) {
  background: #8b96da url(@/components/img/hycz/zp12.png) no-repeat center
    center;
  background-size: cover;
}
.cd-images-list > li > a {
  /* used to vertically align the h2 child -  mobile version only */
  display: table;
  height: 100%;
  width: 100%;
}
.cd-images-list h2 {
  /* used to vertically align h2 -  mobile version only */
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  font-size: 3rem;
  color: #ffffff;
  font-weight: 700;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@media only screen and (min-width: 768px) {
  .cd-images-list::before {
    /* never visible - this is used in jQuery to check the current MQ */
    content: 'desktop';
  }
  .cd-images-list > li > a {
    display: block;
    padding: 4em 3em;
    cursor: default;
    pointer-events: none;
  }
  .cd-images-list h2 {
    font-size: 5.5rem;
    text-align: left;
  }
}

/* -------------------------------- 

Content block

-------------------------------- */
.cd-content-block {
  /* move the block outside the viewport (to the right) - mobile only */
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  -webkit-transform: translateX(100%);
  -moz-transform: translateX(100%);
  -ms-transform: translateX(100%);
  -o-transform: translateX(100%);
  transform: translateX(100%);
  -webkit-transition: -webkit-transform 0.3s;
  -moz-transition: -moz-transform 0.3s;
  transition: transform 0.3s;
}
.cd-content-block.is-visible {
  -webkit-transform: translateX(0);
  -moz-transform: translateX(0);
  -ms-transform: translateX(0);
  -o-transform: translateX(0);
  transform: translateX(0);
}
@media screen and (max-width: 768px) {
  .cd-content-block.is-visible {
    border: 1px solid black;
    margin-top: 56px;
  }
}
.cd-content-block > ul {
  height: 100%;
}
.cd-content-block > ul > li {
  position: absolute;
  height: 100%;
  padding: 1em;
  /* overflow-y: scroll; */
  background-color: #ffffff;
  opacity: 0;
  visibility: hidden;
}
.cd-content-block > ul > li.is-selected {
  /* this is the selected content */
  position: relative;
  opacity: 1;
  visibility: visible;
  -webkit-overflow-scrolling: touch;
}
.cd-content-block h2 {
  line-height: 1.2;
  font-weight: 700;
  font-size: 2.3rem;
  margin-bottom: 1em;
}
.cd-content-block p {
  line-height: 1.4;
  color: #85868d;
  font-size: 14px;
}
.cd-content-block .cd-close {
  /* 'X' icon to close the content block -  mobile only */
  position: fixed;
  top: 0;
  right: 0;
  height: 44px;
  width: 44px;
  /* image replacement */
  overflow: hidden;
  text-indent: 100%;
  white-space: nowrap;
  color: transparent;
  -webkit-transform: scale(0);
  -moz-transform: scale(0);
  -ms-transform: scale(0);
  -o-transform: scale(0);
  transform: scale(0);
  -webkit-transition: -webkit-transform 0.2s;
  -moz-transition: -moz-transform 0.2s;
  transition: transform 0.2s;
}
.cd-content-block .cd-close::after,
.cd-content-block .cd-close::before {
  /* these are the 2 lines of the 'X' icon */
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: 2px;
  height: 24px;
  background-color: #343642;
  /* Force Hardware Acceleration */
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
  -ms-transform: translateZ(0);
  -o-transform: translateZ(0);
  transform: translateZ(0);
}
.cd-content-block .cd-close::after {
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  -moz-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  -ms-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  -o-transform: translateX(-50%) translateY(-50%) rotate(45deg);
  transform: translateX(-50%) translateY(-50%) rotate(45deg);
}
.cd-content-block .cd-close::before {
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  -moz-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  -ms-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  -o-transform: translateX(-50%) translateY(-50%) rotate(-45deg);
  transform: translateX(-50%) translateY(-50%) rotate(-45deg);
}
.cd-content-block .cd-close.is-scaled-up {
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
}
.no-touch .cd-content-block .cd-close.is-scaled-up:hover {
  -webkit-transform: scale(1.2);
  -moz-transform: scale(1.2);
  -ms-transform: scale(1.2);
  -o-transform: scale(1.2);
  transform: scale(1.2);
}
@media only screen and (min-width: 768px) {
  .cd-content-block {
    /* reset style */
    position: static;
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
  }
  .cd-content-block > ul > li {
    /* reset style */
    opacity: 1;
    visibility: visible;
    padding: 2em;
  }
  .cd-content-block > ul > li.overflow-hidden {
    /* this class is used during the animation (slider change) to hide the scrolling bar */
    overflow: hidden;
  }
  .cd-content-block h2 {
    font-size: 3rem;
  }
  .cd-content-block .cd-close {
    display: none;
  }
}

/* ---------------------------------------------- 

Desktop slider - both image and content blocks

---------------------------------------------- */
@media only screen and (min-width: 768px) {
  .cd-content-block p {
    margin-bottom: 1em;
    line-height: 1.6;
    color: #85868d;
    font-size: 19px;
  }
  .cd-image-block {
    /* slider style - desktop version only */
    width: 40%;
    float: left;
    height: 90vh;
    overflow: hidden;
  }
  .cd-content-block {
    /* slider style - desktop version only */
    width: 60%;
    float: left;
    height: 90vh;
    overflow: hidden;
  }
  .cd-image-block > ul,
  .cd-content-block > ul {
    position: relative;
    height: 100%;
  }
  .cd-image-block > ul > li,
  .cd-content-block > ul > li {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    /* Force Hardware Acceleration */
    -webkit-transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    will-change: transform;
    /* by default, the items are moved to the right - relative to their parent elements */
    -webkit-transform: translateX(100%);
    -moz-transform: translateX(100%);
    -ms-transform: translateX(100%);
    -o-transform: translateX(100%);
    transform: translateX(100%);
    -webkit-transition: -webkit-transform 0.5s;
    -moz-transition: -moz-transform 0.5s;
    transition: transform 0.5s;
  }
  .cd-image-block > ul > li.is-selected,
  .cd-content-block > ul > li.is-selected {
    /* this is the visible item */
    position: absolute;
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
  }
  .cd-image-block > ul > li.move-left,
  .cd-content-block > ul > li.move-left {
    /* this is the item hidden on the left */
    -webkit-transform: translateX(-100%);
    -moz-transform: translateX(-100%);
    -ms-transform: translateX(-100%);
    -o-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}
/* -------------------------------- 

Slider navigation

-------------------------------- */
.block-navigation {
  /* this is the slider navigation - desktop version only */
  display: none;
}
@media only screen and (min-width: 768px) {
  .block-navigation {
    display: block;
    position: absolute !important;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 39px !important;
  }
  .block-navigation::after {
    clear: both;
    content: '';
    display: table;
  }
  .block-navigation li {
    position: static !important;
    width: 50% !important;
    height: 50px !important;
    line-height: 50px !important;
    text-align: center !important;
    background-color: rgba(0, 0, 0, 0.5) !important;
    -webkit-transition: background 0.2s;
    -moz-transition: background 0.2s;
    transition: background 0.2s !important;
    transform: translateX(0) !important;
  }
  .block-navigation li:hover {
    background-color: rgba(0, 0, 0, 0.7) !important;
  }
  .block-navigation li:first-of-type {
    float: left;
  }
  .block-navigation li:last-of-type {
    float: right;
  }
  .block-navigation button {
    display: block;
    height: 100%;
    width: 100%;
    color: #ffffff;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .block-navigation button.inactive {
    opacity: 0.3;
    cursor: not-allowed;
  }
}

/* -------------------------------- 

Javascript disabled

-------------------------------- */
@media only screen and (min-width: 768px) {
  .no-js .cd-content-block {
    display: none;
  }

  .no-js .cd-image-block {
    width: 100%;
    overflow: visible;
  }

  .no-js .cd-images-list::after {
    clear: both;
    content: '';
    display: table;
  }

  .no-js .cd-images-list > li {
    position: static;
    width: 50%;
    float: left;
    height: 400px;
    -webkit-transform: translateX(0);
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -o-transform: translateX(0);
    transform: translateX(0);
  }
  .no-js .cd-images-list > li.is-selected {
    position: static;
  }

  .no-js .cd-images-list > li > a {
    cursor: pointer;
    pointer-events: auto;
  }

  .no-js .block-navigation {
    display: none;
  }
}
.jzbutton {
  cursor: pointer;
  border: none;
  background-color: transparent;
  outline: none;
  font-size: 1.6rem;
}
@media screen and (min-width: 2000px) {
  .jzh {
    font-size: 60px;
    margin-bottom: 60px;
    padding-bottom: 60px;
  }
  .jzp {
    font-size: 30px;
  }
  .jzleft {
    padding: 20px 50px 20px 20px;
  }
  .jzimg {
    height: 700px;
    width: 100%;
  }
  .jzcph {
    font-size: 60px;
  }
  /* 头部 */
  .page-heading .heading-content h1 {
    font-size: 40px;
  }
  .zzitem li a {
    margin: 0 50px;
    font-size: 25px;
  }
  .cd-images-list h2 {
    font-size: 7rem;
  }
  .cd-content-block h2 {
    font-size: 5rem;
  }
  .cd-content-block p {
    font-size: 22px;
  }
}
</style>
